module.exports = __webpack_public_path__ + "static/media/YourStoryOurStory-738x57px@2x.86b05d60.webp";